export default __webpack_public_path__ + "static/media/15060 - Mlitman.e6265ff5.jpeg";